/**
 * Bundle product template: waveform player, count-up, sticky ATC, read more, scarcity UI.
 */

/** File stem prefix → Shopify product handle when they differ. */
const PACK_HANDLE_ALIASES = {
  'deep-and-jazz-house-2': 'deep-jazz-house-2',
  'melodic-house-and-deep-techno': 'melodic-house-deep-techno'
};

function normalizePackHandle(handle) {
  const h = String(handle || '').trim();
  return PACK_HANDLE_ALIASES[h] || h;
}

function onDocumentReady(fn) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn);
  } else {
    fn();
  }
}

const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function formatMoney(cents) {
  const fmt = typeof shop_money_format !== 'undefined' ? shop_money_format : '${{amount}}';
  if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, fmt);
  }
  return (cents / 100).toFixed(2);
}

function runMoneyCount(el) {
  const cents = parseInt(el.getAttribute('data-target-cents') || '0', 10);
  const formatted = el.getAttribute('data-formatted') || '';
  if (prefersReducedMotion()) {
    el.textContent = formatted || formatMoney(cents);
    return;
  }
  const t0 = performance.now();
  const dur = 1400;
  function frame(t) {
    const p = Math.min(1, (t - t0) / dur);
    const eased = 1 - Math.pow(1 - p, 3);
    const v = Math.round(cents * eased);
    el.textContent = formatMoney(v);
    if (p < 1) requestAnimationFrame(frame);
    else el.textContent = formatted || formatMoney(cents);
  }
  requestAnimationFrame(frame);
}

function runIntCount(el) {
  const target = parseInt(el.getAttribute('data-target') || '0', 10);
  const suffix = el.getAttribute('data-suffix') || '';
  if (prefersReducedMotion()) {
    el.textContent = `${target}${suffix}`;
    return;
  }
  const t0 = performance.now();
  const dur = 1400;
  function frame(t) {
    const p = Math.min(1, (t - t0) / dur);
    const eased = 1 - Math.pow(1 - p, 3);
    const v = Math.round(target * eased);
    el.textContent = `${v}${suffix}`;
    if (p < 1) requestAnimationFrame(frame);
    else el.textContent = `${target}${suffix}`;
  }
  requestAnimationFrame(frame);
}

function initCountUp(root) {
  const scopes = root.querySelectorAll('[data-ug-count-scope]');
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const scope = entry.target;
        io.unobserve(scope);
        scope.querySelectorAll('[data-ug-count-money]').forEach((el) => runMoneyCount(el));
        scope.querySelectorAll('[data-ug-count-int]').forEach((el) => runIntCount(el));
      });
    },
    { threshold: 0.25 }
  );
  scopes.forEach((s) => io.observe(s));
}

function portStickyToBody(el) {
  if (typeof window.ugPortStickyToBody === 'function') {
    window.ugPortStickyToBody(el);
  } else if (el && el.parentNode !== document.body) {
    document.body.appendChild(el);
  }
}

function initStickyBar() {
  document.querySelectorAll('body > [data-ug-bundle-sticky]').forEach(function (el) {
    el.remove();
  });
  const sticky = document.querySelector('.main-content [data-ug-bundle-sticky]');
  const anchor = document.getElementById('ug-bundle-buy-anchor');
  if (!sticky || !anchor) return;
  portStickyToBody(sticky);
  const io = new IntersectionObserver(
    (entries) => {
      const e = entries[0];
      if (!e) return;
      sticky.hidden = e.isIntersecting;
    },
    { rootMargin: '0px 0px 0px 0px', threshold: 0 }
  );
  io.observe(anchor);
}

function initReadMore() {
  const btn = document.querySelector('[data-ug-bundle-readmore]');
  const more = document.getElementById('ug-bundle-desc-more');
  if (!btn || !more) return;
  btn.addEventListener('click', () => {
    const open = more.hidden;
    more.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.classList.toggle('is-open', open);
  });
}

function initScarcity() {
  const root = document.querySelector('[data-ug-bundle-scarcity]');
  if (!root) return;
  const bar = root.querySelector('[data-ug-scarcity-bar]');
  const fill = root.querySelector('[data-ug-scarcity-fill]');
  if (bar && fill) {
    const x = parseInt(bar.getAttribute('data-x') || '0', 10);
    const y = parseInt(bar.getAttribute('data-y') || '1', 10);
    const ratio = y > 0 ? x / y : 0;
    bar.classList.remove('ug-bundle-scarcity__bar-track--warn', 'ug-bundle-scarcity__bar-track--crit');
    if (ratio < 0.1) bar.classList.add('ug-bundle-scarcity__bar-track--crit');
    else if (ratio < 0.3) bar.classList.add('ug-bundle-scarcity__bar-track--warn');
  }
  const cd = root.querySelector('[data-ug-bundle-countdown]');
  if (!cd) return;
  const endStr = cd.getAttribute('data-end');
  if (!endStr) {
    cd.hidden = true;
    return;
  }
  const end = new Date(endStr);
  if (Number.isNaN(end.getTime())) {
    cd.hidden = true;
    return;
  }
  const out = cd.querySelector('[data-ug-countdown-display]');
  if (!out) return;
    function tick() {
      const now = new Date();
      let sec = Math.floor((end.getTime() - now.getTime()) / 1000);
      if (sec <= 0) {
        out.textContent = '—';
        return;
      }
      const d = Math.floor(sec / 86400);
      sec = sec % 86400;
      const h = Math.floor(sec / 3600);
      sec = sec % 3600;
      const m = Math.floor(sec / 60);
      const s = sec % 60;
      out.textContent = `${d}d ${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    }
  tick();
  setInterval(tick, 1000);
}

function parseDemos() {
  const el = document.getElementById('ug-bundle-demos-json');
  if (!el) return [];
  try {
    return JSON.parse(el.textContent || '[]');
  } catch {
    return [];
  }
}

async function initWaveform() {
  const container = document.getElementById('ug-bundle-waveform');
  const playBtn = document.querySelector('[data-ug-bundle-play]');
  const tabsHost = document.querySelector('[data-ug-bundle-tabs]');
  const playerRoot = document.querySelector('[data-ug-bundle-player]');
  if (!container || !playBtn || !playerRoot) return;

  const demos = parseDemos();
  if (!demos.length) return;

  let WaveSurfer;
  try {
    const mod = await import('https://unpkg.com/wavesurfer.js@7.7.3/dist/wavesurfer.esm.js');
    WaveSurfer = mod.default || mod;
  } catch {
    container.innerHTML =
      '<p class="ug-bundle-player__fallback-msg">Preview unavailable in this browser.</p>';
    return;
  }

  let idx = 0;
  const wavesurfer = WaveSurfer.create({
    container,
    height: 96,
    waveColor: 'rgba(212, 255, 77, 0.42)',
    progressColor: '#d4ff4d',
    cursorColor: '#d4ff4d',
    barWidth: 2,
    barGap: 1,
    barRadius: 2,
    normalize: true,
  });

  function loadDemo(i) {
    idx = i;
    const d = demos[i];
    if (!d || !d.url) return;
    wavesurfer.load(d.url);
    tabsHost?.querySelectorAll('[role="tab"]').forEach((tab, j) => {
      tab.setAttribute('aria-selected', j === i ? 'true' : 'false');
      tab.classList.toggle('is-active', j === i);
    });
  }

  if (demos.length > 1 && tabsHost) {
    tabsHost.hidden = false;
    demos.forEach((d, i) => {
      const tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'ug-bundle-player__tab';
      tab.setAttribute('role', 'tab');
      tab.textContent = d.label || `Demo ${i + 1}`;
      tab.addEventListener('click', () => loadDemo(i));
      tabsHost.appendChild(tab);
    });
  }

  loadDemo(0);

  wavesurfer.on('play', () => {
    playBtn.setAttribute('aria-pressed', 'true');
  });
  wavesurfer.on('pause', () => {
    playBtn.setAttribute('aria-pressed', 'false');
  });

  playBtn.addEventListener('click', () => {
    wavesurfer.playPause();
  });
}

function getPackCount() {
  const el = document.getElementById('ug-bundle-pack-count');
  if (!el) return 1;
  try {
    const n = parseInt(JSON.parse(el.textContent || '1'), 10);
    return n > 0 ? n : 1;
  } catch {
    return 1;
  }
}

function updateValueMath(select) {
  const opt = select.options[select.selectedIndex];
  if (!opt) return;
  const price = parseInt(opt.getAttribute('data-price-cents') || '0', 10);
  const compare = parseInt(opt.getAttribute('data-compare-cents') || String(price), 10);
  const save = Math.max(0, compare - price);
  const pct = compare > price ? Math.round((save * 100) / compare) : 0;
  const packCount = getPackCount();
  const perPack = Math.floor(price / packCount);

  const root = document.querySelector('[data-ug-bundle-value]');
  if (!root) return;

  const priceEl = root.querySelector('[data-ug-bundle-price]');
  if (priceEl) {
    const fp = formatMoney(price);
    priceEl.textContent = fp;
    priceEl.setAttribute('data-price-cents', String(price));
  }
  const saveEl = root.querySelector('[data-ug-bundle-save]');
  const saveWrap = root.querySelector('[data-ug-save-wrap]');
  const pctWrap = root.querySelector('[data-ug-pct-wrap]');
  if (save > 0) {
    saveWrap?.removeAttribute('hidden');
    pctWrap?.removeAttribute('hidden');
    root.classList.remove('ug-bundle-value--no-sale');
    if (saveEl) saveEl.textContent = formatMoney(save);
    const intEl = root.querySelector('[data-ug-count-int]');
    if (intEl) {
      const suf = intEl.getAttribute('data-suffix') || '';
      intEl.textContent = `${pct}${suf}`;
      intEl.setAttribute('data-target', String(pct));
    }
  } else {
    saveWrap?.setAttribute('hidden', '');
    pctWrap?.setAttribute('hidden', '');
    root.classList.add('ug-bundle-value--no-sale');
  }
  const perEl = root.querySelector('[data-ug-bundle-per-money]');
  if (perEl) perEl.textContent = formatMoney(perPack);

  const stickyPrice = document.querySelector('[data-ug-bundle-sticky-price]');
  if (stickyPrice) stickyPrice.textContent = formatMoney(price);

  const actualPrice = document.querySelector('[data-ug-bundle-actual-price]');
  if (actualPrice) actualPrice.textContent = formatMoney(price);
}

function initVariants() {
  const sel = document.querySelector('[data-ug-bundle-variant-main]');
  if (!sel) return;
  sel.addEventListener('change', () => updateValueMath(sel));
  updateValueMath(sel);
}

function normHandle(s) {
  return String(s).replace(/-and-/g, '-').toLowerCase();
}

function resolveCover(covers, handle) {
  if (!covers || !handle) return null;
  if (covers[handle]) return covers[handle];
  const h0 = normHandle(handle);
  for (const k of Object.keys(covers)) {
    if (normHandle(k) === h0) return covers[k];
  }
  return null;
}

function titleFromHandle(handle) {
  return handle
    .split('-')
    .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1) : w))
    .join(' ')
    .replace(/\bAnd\b/g, '&');
}

// Tiles render at most ~205px CSS wide, so a single 600px source stays crisp at
// DPR 1-3 while staying tiny (~34KB WebP). We intentionally avoid srcset/sizes:
// responsive images send Width/DPR client hints that Shopify's image CDN honors,
// which downscales the cover to the tiny tile size (blurry) and overrides the
// width param in the URL.
const MOSAIC_TILE_WIDTH = 600;

/** Shopify CDN file images support on-the-fly resizing via the width param. */
function coverUrlAtWidth(url, width) {
  if (!url) return '';
  return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
}

const MOSAIC_STAGGER_MS = 24;
const MOSAIC_STAGGER_CAP_MS = 1400;

function revealMosaicTiles(grid) {
  if (!grid || grid.dataset.ugMosaicRevealed === 'true') return;
  const tiles = grid.querySelectorAll('.ug-bundle-mosaic__tile');
  if (!tiles.length) return;

  if (prefersReducedMotion()) {
    grid.classList.add('is-revealed');
    grid.dataset.ugMosaicRevealed = 'true';
    return;
  }

  tiles.forEach((tile, i) => {
    const delay = Math.min(i * MOSAIC_STAGGER_MS, MOSAIC_STAGGER_CAP_MS);
    tile.style.setProperty('--ug-mosaic-delay', `${delay}ms`);
  });

  grid.classList.add('is-revealed');
  grid.dataset.ugMosaicRevealed = 'true';
}

function scheduleMosaicReveal(grid) {
  if (!grid || grid.dataset.ugMosaicRevealed === 'true') return;
  if (!grid.querySelector('.ug-bundle-mosaic__tile')) return;

  const run = () => revealMosaicTiles(grid);
  const target = grid.closest('.ug-bundle-mosaic') || grid;

  if (prefersReducedMotion()) {
    run();
    return;
  }

  const inView = () => {
    const rect = target.getBoundingClientRect();
    return rect.top < window.innerHeight * 0.92 && rect.bottom > 0;
  };

  if (inView()) {
    requestAnimationFrame(() => requestAnimationFrame(run));
    return;
  }

  if (grid._ugMosaicRevealObs) return;

  const io = new IntersectionObserver(
    (entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      io.disconnect();
      grid._ugMosaicRevealObs = null;
      run();
    },
    { threshold: 0.08, rootMargin: '48px 0px' }
  );
  grid._ugMosaicRevealObs = io;
  io.observe(target);

  window.setTimeout(() => {
    if (grid.dataset.ugMosaicRevealed !== 'true') run();
  }, 4000);
}

function initMosaicReveal() {
  const grid = document.querySelector('[data-ug-bundle-mosaic]');
  if (grid) scheduleMosaicReveal(grid);
}

async function initMosaic() {
  const grid = document.querySelector('[data-ug-bundle-mosaic]');
  if (!grid || grid.dataset.mosaicFromMetafield === 'true') return;
  if (grid.querySelector('a.ug-bundle-mosaic__tile')) return;

  const coversUrl = grid.getAttribute('data-covers-url');
  const handlesUrl = grid.getAttribute('data-handles-url');
  const shopUrl = (grid.getAttribute('data-shop-url') || '').replace(/\/$/, '');
  if (!coversUrl || !handlesUrl) return;

  try {
    const [covers, handles] = await Promise.all([
      fetch(coversUrl, { credentials: 'same-origin' }).then((r) => r.json()),
      fetch(handlesUrl, { credentials: 'same-origin' }).then((r) => r.json()),
    ]);
    if (!Array.isArray(handles) || !handles.length) return;

    const frag = document.createDocumentFragment();
    handles.forEach((handle) => {
      const cover = resolveCover(covers, handle);
      const title = titleFromHandle(handle);
      const href = `${shopUrl}/products/${handle}`;
      const tile = document.createElement('a');
      tile.className = 'ug-bundle-mosaic__tile';
      tile.href = href;
      tile.setAttribute('aria-label', `Open pack: ${title}`);

      const media = document.createElement('span');
      media.className = 'ug-bundle-mosaic__media';
      if (cover && cover.url) {
        const img = document.createElement('img');
        img.src = coverUrlAtWidth(cover.url, MOSAIC_TILE_WIDTH);
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        if (cover.width) img.width = cover.width;
        if (cover.height) img.height = cover.height;
        media.appendChild(img);
      } else {
        const ph = document.createElement('span');
        ph.className = 'ug-bundle-mosaic__ph';
        ph.setAttribute('aria-hidden', 'true');
        media.appendChild(ph);
      }

      const overlay = document.createElement('span');
      overlay.className = 'ug-bundle-mosaic__overlay';
      overlay.setAttribute('aria-hidden', 'true');

      tile.append(media, overlay);
      frag.appendChild(tile);
    });

    grid.textContent = '';
    grid.appendChild(frag);
    scheduleMosaicReveal(grid);
  } catch {
    /* keep empty grid */
  }
}

const SC_CLIENT_ID = 'YarHB9tGQ1DVVGYJwrebP5KdAqo9mFPn';
const scResolveCache = new Map();

async function resolveScProgressive(apiUrl) {
  if (!apiUrl) return '';
  if (scResolveCache.has(apiUrl)) return scResolveCache.get(apiUrl);
  try {
    const res = await fetch(`${apiUrl}?client_id=${encodeURIComponent(SC_CLIENT_ID)}`);
    if (!res.ok) return '';
    const data = await res.json();
    const url = data.url || '';
    scResolveCache.set(apiUrl, url);
    return url;
  } catch {
    return '';
  }
}

function encodeAudioUrl(url) {
  if (!url) return '';
  return String(url).replace(/#/g, '%23');
}

function firstProductDemoUrl(manifest, handle) {
  const h = normalizePackHandle(handle || '');
  if (!manifest || !h) return '';
  const list = manifest[h];
  if (!Array.isArray(list) || !list[0] || !list[0].url) return '';
  return encodeAudioUrl(list[0].url);
}

function buildDemoRow(demo, playVerb) {
  const row = document.createElement('article');
  row.className = 'ug-bundle-demo-row';
  row.setAttribute('role', 'listitem');

  const art = document.createElement('div');
  art.className = 'ug-product-card__art ug-bundle-demo-row__art';

  const imgLink = document.createElement('a');
  imgLink.href = demo.productUrl || '#';
  imgLink.setAttribute('aria-hidden', 'true');
  imgLink.tabIndex = -1;
  const img = document.createElement('img');
  img.src = demo.image || '';
  img.alt = '';
  img.loading = 'lazy';
  img.decoding = 'async';
  imgLink.appendChild(img);
  art.appendChild(imgLink);

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'ug-audio-play-trigger ug-audio-play-trigger--card';
  btn.setAttribute('data-ug-audio-title', demo.title || '');
  btn.setAttribute(
    'data-ug-audio-image',
    demo.bundlePlayerImage || demo.image || ''
  );
  // Demos previewed from a bundle PDP represent the *bundle*, not the individual
  // packs: keep each pack's title + audio but point the player artwork and
  // Add-to-Cart at the bundle product itself (the row's own art/title links below
  // still navigate to the individual pack for browsing).
  btn.setAttribute(
    'data-ug-audio-product-url',
    demo.bundlePlayerUrl || demo.productUrl || '#'
  );
  const audioSrc = (demo.audioSrc || '').trim();
  if (audioSrc) {
    btn.setAttribute('data-ug-audio-src', audioSrc);
  }
  if (!audioSrc && demo.progressiveUrl) {
    btn.setAttribute('data-ug-sc-progressive', demo.progressiveUrl);
  }
  btn.setAttribute(
    'aria-label',
    `${playVerb}: ${demo.title || demo.handle || 'Pack demo'}`
  );
  btn.innerHTML =
    '<span class="ug-audio-play-trigger__ring" aria-hidden="true"></span>' +
    '<span class="ug-audio-play-trigger__icon" aria-hidden="true"></span>';
  art.appendChild(btn);

  const title = document.createElement('p');
  title.className = 'ug-bundle-demo-row__title';
  const titleLink = document.createElement('a');
  titleLink.href = demo.productUrl || '#';
  titleLink.textContent = demo.title || demo.handle || '';
  title.appendChild(titleLink);

  row.append(art, title);
  return row;
}

function initBundleScPlayResolve() {
  document.body.addEventListener(
    'click',
    async (e) => {
      const btn = e.target.closest('[data-ug-bundle-demos] .ug-audio-play-trigger');
      if (!btn) return;

      const existingSrc = (btn.getAttribute('data-ug-audio-src') || '').trim();
      if (existingSrc) return;

      const prog = btn.getAttribute('data-ug-sc-progressive');
      if (!prog) return;

      e.preventDefault();
      e.stopPropagation();

      btn.classList.add('is-loading');
      let url = '';
      try {
        url = await resolveScProgressive(prog);
      } catch {
        url = '';
      }
      btn.classList.remove('is-loading');
      if (!url) {
        btn.setAttribute('aria-disabled', 'true');
        return;
      }

      btn.setAttribute('data-ug-audio-src', url);
      btn.removeAttribute('aria-disabled');

      if (typeof window.ugAudioPlayerPlayFromButton === 'function') {
        window.ugAudioPlayerPlayFromButton(btn);
      }
    },
    true
  );
}

function stripHtml(html) {
  const tmp = document.createElement('div');
  tmp.innerHTML = html || '';
  return (tmp.textContent || '').replace(/\s+/g, ' ').trim();
}

function initHeroAside() {
  const aside = document.querySelector('[data-ug-bundle-hero-aside]');
  if (!aside) return;

  const productId = aside.getAttribute('data-product-id');
  const ratingLink = aside.querySelector('[data-ug-bundle-rating-link]');
  const ratingCountEl = aside.querySelector('[data-ug-bundle-rating-count]');
  const quotesEl = aside.querySelector('[data-ug-bundle-hero-quotes]');
  const ratingLabelTpl = aside.getAttribute('data-rating-label') || '__COUNT__ ratings';

  function formatRatingLabel(count) {
    return ratingLabelTpl.replace('__COUNT__', String(count));
  }

  function appendHeroQuote(text, author) {
    if (!quotesEl || !text) return;
    const figure = document.createElement('figure');
    figure.className = 'ug-bundle-hero__quote';
    const blockquote = document.createElement('blockquote');
    blockquote.className = 'ug-bundle-hero__quote-text';
    blockquote.textContent = text;
    figure.appendChild(blockquote);
    if (author) {
      const cap = document.createElement('figcaption');
      cap.className = 'ug-bundle-hero__quote-author';
      cap.textContent = `— ${author}`;
      figure.appendChild(cap);
    }
    quotesEl.appendChild(figure);
  }

  function applyJdgm() {
    const widget = window.jdgm?.data?.reviewWidget?.[productId];
    if (!widget) return false;

    const count =
      widget.reviews_count ??
      widget.review_count ??
      widget.number_of_reviews ??
      widget.total_reviews ??
      0;

    if (count > 0 && ratingLink && ratingCountEl) {
      ratingLink.hidden = false;
      ratingLink.classList.remove('ug-bundle-hero__rating--pending');
      ratingCountEl.textContent = formatRatingLabel(count);
      ratingLink.setAttribute('aria-label', formatRatingLabel(count));
    }

    if (quotesEl && quotesEl.children.length === 0 && Array.isArray(widget.reviews)) {
      const picks = widget.reviews
        .map((rev) => {
          const body = stripHtml(rev.body || rev.review || rev.title || '');
          const author =
            rev.reviewer?.name ||
            rev.reviewer_name ||
            rev.author ||
            rev.name ||
            '';
          return { body, author };
        })
        .filter((r) => r.body.length >= 24)
        .slice(0, 2);
      picks.forEach((r) => appendHeroQuote(r.body, r.author));
    }

    return true;
  }

  if (!applyJdgm()) {
    let tries = 0;
    const timer = window.setInterval(() => {
      if (applyJdgm() || ++tries >= 40) window.clearInterval(timer);
    }, 250);
  }
}

async function initInlineDemos() {
  const root = document.querySelector('.ug-bundle-demos--hero[data-ug-bundle-demos]');
  const list = root?.querySelector('[data-ug-bundle-demos-list]');
  if (!root || !list) return;

  const url = root.getAttribute('data-demos-url');
  if (!url) return;

  const productDemosUrl =
    root.getAttribute('data-product-demos-url') ||
    (typeof window.UG_PRODUCT_DEMOS_MANIFEST_URL === 'string'
      ? window.UG_PRODUCT_DEMOS_MANIFEST_URL
      : '');

  const playVerb = root.getAttribute('data-preview-play-verb') || 'Preview';
  const bundlePlayerImage = root.getAttribute('data-bundle-player-image') || '';
  const bundlePlayerUrl = root.getAttribute('data-bundle-player-url') || '';

  try {
    const [bundleData, productDemos] = await Promise.all([
      loadJsonAsset(url),
      loadJsonAsset(productDemosUrl)
    ]);
    if (!bundleData) return;

    const demos = bundleData.demos || [];
    const frag = document.createDocumentFragment();
    let firstPlayBtn = null;

    demos.forEach((demo) => {
      const shopifySrc = firstProductDemoUrl(productDemos, demo.handle);
      const progressiveUrl = (demo.progressiveUrl || '').trim();
      if (!shopifySrc && !progressiveUrl) return;

      const row = buildDemoRow(
        {
          ...demo,
          audioSrc: shopifySrc,
          progressiveUrl: shopifySrc ? '' : progressiveUrl,
          bundlePlayerImage,
          bundlePlayerUrl
        },
        playVerb
      );
      frag.appendChild(row);

      if (!firstPlayBtn) {
        firstPlayBtn = row.querySelector('.ug-audio-play-trigger[data-ug-audio-src]');
      }
    });

    list.appendChild(frag);

    const heroBtn = document.querySelector(
      '.ug-bundle-hero__visual .ug-audio-play-trigger--hero'
    );
    if (heroBtn && firstPlayBtn) {
      const src = firstPlayBtn.getAttribute('data-ug-audio-src');
      if (src) heroBtn.setAttribute('data-ug-audio-src', src);
    }
  } catch {
    /* list stays empty */
  }
}

function packHandleFromFile(file) {
  const m = String(file || '').match(/^undrgrnd_([^_]+(?:-[^_]+)*?)_(?:US|RR)_/i);
  return m ? normalizePackHandle(m[1]) : '';
}

async function loadJsonAsset(url) {
  if (!url) return null;
  try {
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}

async function initBundlePreviewGrid() {
  const root = document.querySelector('[data-ug-bundle-preview-grid]');
  if (!root) return;

  const playVerb = root.getAttribute('data-preview-play-verb') || 'Preview';
  const pauseVerb = root.getAttribute('data-preview-pause-verb') || 'Pause';
  const bundleProductUrl = root.getAttribute('data-product-url') || '';
  const bundleProductImage = root.getAttribute('data-product-image') || '';
  const bundleVariantId = root.getAttribute('data-bundle-variant-id') || '';
  const matchApi = window.ugPreviewAudioMatch;

  let tracks = [];
  const dataEl = document.getElementById('ug-bundle-preview-tracks-data');
  if (dataEl) {
    try {
      tracks = JSON.parse(dataEl.textContent || '[]');
    } catch {
      tracks = [];
    }
  }

  const gridUrl = root.getAttribute('data-grid-url');
  const gridData = await loadJsonAsset(gridUrl);
  if (gridData && Array.isArray(gridData.tracks)) {
    const byLabel = new Map(
      gridData.tracks.map((t) => [(t.label || '').trim(), t])
    );
    tracks = tracks.map((track) => {
      const label = (track.label || '').trim();
      const hit = byLabel.get(label);
      if (!hit || !hit.url) return track;
      return {
        ...track,
        url: hit.url,
        file: hit.file || '',
        packHandle: normalizePackHandle(hit.packHandle || packHandleFromFile(hit.file))
      };
    });
  }

  const needsMatch = tracks.some((t) => !(t.url || '').trim());
  const usedUrls = new Set(tracks.map((t) => t.url).filter(Boolean));
  const manifestUrl = root.getAttribute('data-manifest-url');
  if (needsMatch && manifestUrl && matchApi) {
    try {
      const manifest = await matchApi.loadPreviewManifest(manifestUrl);
      const catalog = matchApi.flattenPreviewCatalog(manifest);
      tracks = tracks.map((track) => {
        if ((track.url || '').trim()) return track;
        const label = (track.label || '').trim();
        if (!label) return track;
        const hit = matchApi.findBestPreviewMatch(label, catalog, usedUrls);
        if (!hit) return track;
        usedUrls.add(hit.url);
        return {
          ...track,
          url: hit.url,
          file: hit.file,
          packHandle: packHandleFromFile(hit.file)
        };
      });
    } catch {
      /* keep tracks without resolved urls */
    }
  }

  const trackByIndex = new Map(tracks.map((t) => [Number(t.index), t]));

  function encodeFileUrl(url) {
    if (matchApi?.encodeFileUrl) return matchApi.encodeFileUrl(url);
    if (!url) return '';
    return String(url).replace(/#/g, '%23');
  }

  function syncCellPlayingState() {
    root.querySelectorAll('[data-ug-bundle-preview-cell]').forEach((cell) => {
      const btn = cell.querySelector('[data-ug-bundle-preview-play]');
      const playing = !!(btn && btn.classList.contains('isPlaying'));
      cell.classList.toggle('is-playing', playing);
      if (!btn) return;
      btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
      const label =
        cell.querySelector('.ug-bundle-preview-cell__label')?.textContent?.trim() ||
        `Preview sound ${cell.getAttribute('data-ug-bundle-preview-index') || ''}`;
      btn.setAttribute('aria-label', `${playing ? pauseVerb : playVerb}: ${label}`);
    });
  }

  root.querySelectorAll('[data-ug-bundle-preview-cell]').forEach((cell) => {
    const idx = Number(cell.getAttribute('data-ug-bundle-preview-index'));
    const track = trackByIndex.get(idx);
    const btn = cell.querySelector('[data-ug-bundle-preview-play]');
    if (!btn || !track) return;

    const url = encodeFileUrl(track.url);
    if (url) btn.setAttribute('data-ug-audio-src', url);
    if (track.label) btn.setAttribute('data-ug-audio-title', track.label);

    if (bundleProductUrl) btn.setAttribute('data-ug-audio-product-url', bundleProductUrl);
    if (bundleProductImage) btn.setAttribute('data-ug-audio-image', bundleProductImage);
    if (bundleVariantId) btn.setAttribute('data-ug-audio-variant-id', bundleVariantId);
    btn.classList.add('ug-audio-play-trigger');
    btn.setAttribute('data-ug-audio-scope', 'single');
  });

  root.querySelectorAll('.ug-audio-play-trigger').forEach((btn) => {
    const mo = new MutationObserver(syncCellPlayingState);
    mo.observe(btn, { attributes: true, attributeFilter: ['class'] });
  });

  const globalAudio = document.getElementById('ug-audio-element');
  if (globalAudio) {
    ['play', 'pause', 'ended'].forEach((ev) => {
      globalAudio.addEventListener(ev, syncCellPlayingState);
    });
  }

  syncCellPlayingState();
}

/**
 * Boot the bundle PDP. Safe to call repeatedly: it re-initialises the freshly
 * rendered bundle DOM after an instant-nav (Swup) swap. The body-level
 * delegated listener is bound once; per-page init runs once per rendered DOM
 * (guarded by data-ug-bundle-booted) so it never double-binds or duplicates rows.
 */
function bootBundleProduct() {
  // Delegated click listener lives on document.body, which Swup never swaps,
  // so it must be attached only once for the whole session.
  if (!window.__ugBundleScResolveBound) {
    window.__ugBundleScResolveBound = true;
    initBundleScPlayResolve();
  }

  const root = document.querySelector('[data-ug-bundle-product]');
  if (!root) {
    if (typeof window.ugRemoveOrphanStickyBars === 'function') {
      window.ugRemoveOrphanStickyBars();
    }
    return;
  }
  if (root.dataset.ugBundleBooted === '1') return;
  root.dataset.ugBundleBooted = '1';

  initCountUp(root);
  initStickyBar();
  initReadMore();
  initScarcity();
  initVariants();
  initInlineDemos();
  initMosaic();
  initMosaicReveal();
  initHeroAside();
  initBundlePreviewGrid();
}

// Exposed so instant navigation (Swup) can re-init on each page:view.
// See assets/ug-swup-nav.js → ugReinit().
window.ugBootBundleProduct = bootBundleProduct;

onDocumentReady(bootBundleProduct);
